import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/core/auth/auth-store'
import { AUTH_BYPASS } from '@/core/auth/dev-bypass'

// Gate for the elevated admin surface (platform moderation / directory). The
// analogue of clubmanager's RoleGate: renders nothing until the first auth
// snapshot resolves, sends signed-out users to /login, and bounces non-admins
// back to the feed. `isAdmin` = membership in `platform_config/admins.emails`
// + emailVerified, resolved in use-auth-listener BEFORE the store flips out of
// 'initial' — so a real admin deep-linking /admin is never mis-bounced.
export function AdminRoute({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status)
  const isAdmin = useAuthStore((s) => s.isAdmin)
  if (AUTH_BYPASS) return <>{children}</>
  if (status === 'initial') return null
  if (status === 'unauthenticated') return <Navigate to="/login" replace />
  if (!isAdmin) return <Navigate to="/partidos" replace />
  return <>{children}</>
}
